import { APIMethod, fetchData } from "@client";

export async function removeProjectPresetQuery(projectUuid) {
  await fetchData(`/preset/project/${projectUuid}`, APIMethod.DELETE);
}
